import { fromJS } from "immutable";
import * as actionNameTypes from "./actionType";

const initialState = fromJS({
  messages: {
    isLoading: false,
    isAllLoading: false,
    selected: "",
    data: [],
    alldata: [],
    error: "",
    allMessages: [],
    additionalAccountDetails:{},
    isToggle:false
  }
});

const messagingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionNameTypes.messageDataLoadingType:
      return state
        .setIn(["messages", "isLoading"], true)
        .setIn(["messages", "data"], []);
    case actionNameTypes.messagingDataSuccessType:
      return state
        .setIn(["messages", "data"], action.payload)
        .setIn(["messages", "isLoading"], false);
    case actionNameTypes.messagingAllDataLoadingType:
      return state
        .setIn(["messages", "isAllLoading"], true)
        .setIn(["messages", "alldata"], [])
        .setIn(["messages", "allMessages"], []);
    case actionNameTypes.messagingAllDataSuccessType:
      return state
        .setIn(["messages", "alldata"], action.payload)
        .setIn(["messages", "isAllLoading"], false);
    case actionNameTypes.storeAllMessageType:
      return state.setIn(["messages", "allMessages"], action.payload);
    case actionNameTypes.selectionChangeType:
      return state.setIn(["messages", "selected"], action.payload);
    case actionNameTypes.additionalAccountDetailsType:
      return state.setIn(["messages", "additionalAccountDetails"], action.payload);
    case actionNameTypes.messageFullDisplayType:
      return state.setIn(["messages", "isToggle"], !state.getIn(["messages","isToggle"]));
    case actionNameTypes.messageFullDisplayInitialType:
      return state.setIn(["messages", "isToggle"], false);
    default:
      return state;
  }
};

export default messagingReducer;
